<div class="container">
  <div class="flex-grow item">
    <prlw-info-item-ui
      label="Наименование базиса:"
      [value]="basisName"
    ></prlw-info-item-ui>
    <prlw-info-item-ui
      label="Производитель:"
      [value]="manufacturers"
    ></prlw-info-item-ui>
    <prlw-info-item-ui
      label="Станция отгрузки:"
      [value]="stationName"
    ></prlw-info-item-ui>
  </div>
  <div class="flex-grow item">
    <prlw-info-item-ui
      label="Код инструмента:"
      [value]="instrumentCode"
    ></prlw-info-item-ui>
    <prlw-info-item-ui
      label="Название инструмента:"
      [value]="instrumentName"
    ></prlw-info-item-ui>
    <prlw-info-item-ui label="Прогноз:" [value]="forecast"></prlw-info-item-ui>
  </div>
</div>
